<template>
  <modal name="enrollment-status" :clickToClose="false">
    <div class="content">

      <div v-if="patient.temp_pass">
        <h1 class="text-3xl font-bold mb-2" :class="[!companion ? 'light-blue' : 'green']">{{ language.enrolled[language_id] }}</h1>
        <div v-if="showProgress"><img class="m-auto mb-8 w-52" src="../../assets/images/enrolled.png"></div>
        <div v-if="!showProgress">
          <h1 class="text-xl font-bold mb-4 dark-blue">{{ language.text_message[language_id] }}</h1>
        <p class="mx-16 my-4 text-base">{{ language.text_message_link[language_id] }}
        </p>
        </div>

        <div v-if="showProgress">
        <h1 class="text-xl font-bold mb-4 dark-blue">{{ language.message_text_sent[language_id] }}</h1>
        <p class="mb-4">
        {{ language.download_link[language_id]
        }}
        <a
          :class="[!isCompanion ? 'light-blue' : 'green']"
          :href="isCompanion ? 'https://link.companion.health' : language.connections_link[language_id]"
          target="_blank"
          rel="noopener noreferrer"
        >
          {{ isCompanion ? 'https://link.companion.health' : language.connections_link[language_id] }}
        </a>
      </p>
      <p class="mb-4">{{isCompanion ? language.check_spam_companion[language_id] : language.check_spam[language_id] }}</p>
      </div>

        <div v-if="showEnrollmentNumbers">
          <!-- enrollment container -->
          <div class="enrollment-container my-4 enrollment-text">
            <p class="font-bold text-base">{{ language.app_enrollment_status[language_id] }}</p>
            <div class="enrollment-column">
              <div class="column">
                <h3>{{ language.all_time[language_id] }}</h3>
                <p class="enrollment-text-number" :class="[!companion ? 'light-blue' : 'green']">{{ totalEnrollments }}</p>
              </div>
              <div class="column">
                <h3>{{ language.past_week[language_id] }}</h3>
                <p class="enrollment-text-number" :class="[!companion ? 'light-blue' : 'green']">{{ recentEnrollments }}</p>
              </div>
            </div>
          </div>

          <!-- progress container -->
          <p>
            <span class="text-base">{{ language.your_status[language_id] }} </span>
            <span class="text-base" :class="[!companion ? 'light-blue' : 'green']">{{ currentStatus }}</span>
          </p>

        </div>

        <div v-if="!showEnrollmentNumbers && showEnrollmentNumbers != null">
          <hr />
          <div class="my-4" v-if="totalEnrollments == 1">
            <p class="font-bold text-lg">{{ language.enroll_4_more[language_id] }}</p>
          </div>
          <div class="my-4" v-if="totalEnrollments > 1">
            <img class="m-auto w-32" alt="Congrats" src="../../assets/images/confetti.png">
            <p class="font-bold text-lg">{{ language.congrats[language_id] }}</p>
            <p class="font-bold text-lg">{{ language.by_enrolling[language_id] }} {{ enrollments }} {{ language.individuals_you_are[language_id] }} ‘{{
              promotedEnrollerStatus }}‘</p>
            <p v-if="totalEnrollments >= 100" class="font-bold text-lg">{{ language.highest_level[language_id] }}</p>
            <p v-else class="font-bold text-lg">{{ language.enroll[language_id] }} {{ enrollmentsRequired }} {{ language.more_achieve[language_id] }} ‘{{
              nextPromotedEnrollerStatus }}‘ {{language_id == "1" ? 'status' : ''}}</p>
          </div>
        </div>

        <div v-if="showProgress" class="progress my-4">
          <div v-for="(item, index) in progressItems" :key="index" class="circle"
            :class="{ completed: index < progress }">
            <span v-if="index < progress"><img class="check-mark" alt="Check Mark"
                src="../../assets/images/check-mark.png"></span>
            <span v-if="index >= progress" class="no-check-mark"></span>
          </div>
        </div>

        <div v-if="!showProgress && showEnrollmentNumbers">
          <p class="font-bold text-lg">{{ language.enroll[language_id] }} {{ enrollmentsRequired }} {{ language.more_achieve[language_id] }} ‘{{
              promotedEnrollerStatus }}‘ {{language_id == "1" ? 'status' : ''}}</p>
        </div>

        <div v-if="!patient.temp_pass">
          <h1 class="text-xl font-bold mb-8" :class="[!companion ? 'light-blue' : 'green']">{{ language.already_enrolled[language_id] }}</h1>
          <img class="m-auto mb-8 w-52" src="../../assets/images/airballoon.png">
          <p class="mb-4">{{ language.birth_phone[language_id] }}</p>
          <p class="mb-4 text-xl">{{ language.close_window[language_id] }}</p>
        </div>

        <!-- Email -->
        <div class="mb-6" v-if="patient.email">
          <div class="text">{{ language.email_download[language_id] }} {{ patient.email }}</div>
        </div>

        <p class="mb-8 my-4">{{ language.need_help[language_id] }}<a :class="[!companion ? 'light-blue' : 'green']"
            href="mailto:support@connectionsapp.com">support@connectionsapp.com</a></p>

        <button class="w-24" @click="closeModal" :class="{compbutton: companion}">{{ language.close[language_id] }}</button>

      </div>

      <div v-else>
        <h1 class="text-xl font-bold mb-8" :class="[!companion ? 'light-blue' : 'green']">{{ language.already_enrolled[language_id] }}</h1>
        <img class="m-auto mb-8 w-52" src="../../assets/images/airballoon.png">
        <p class="mb-4">{{ language.birth_phone[language_id] }}</p>
        <p class="mb-4 text-xl">{{ language.close_window[language_id] }}</p>
      </div>

    </div>
  </modal>
</template>

<script>
import { translations } from '../../translations'
import { getStaffOnboardCount } from '../../services/integration-profile-service'

export default {
  name: 'EnrollmentStatus',
  components: { // imported components
  },
  props: { // props passed into component
    patient: Object,
    selectedStaff: Object,
    companion: Boolean,
    language_id: Number
  },
  data() { // component props
    return {
      language: translations(),
      loading: false,
      progress: 0,
      totalItems: 5,
      totalEnrollments: 0,
      recentEnrollments: 0,
      showProgress: false,
      showEnrollmentNumbers: null,
      levels: [1, 5, 20, 55, 100],
      promotedEnrollerStatus: "",
      nextPromotedEnrollerStatus: "",
      enrollmentsRequired: 0,
      enrollments: 0,
      currentStatus: ""
    }
  },
  created() {
    this.getStaffEnrollmentCount(this.selectedStaff);
  },
  mounted() { /* Called after the instance has been mounted */ },
  computed: {
    progressItems() {
      return Array.from({ length: this.totalItems }, (_, index) => index);
    }
  },
  methods: { // component functions
    closeModal() {
      this.$emit('close-modal');
      this.$modal.hide('enrollment-status');
    },
    getStaffEnrollmentCount(selectedStaff) {
      // get staff onboard count
      getStaffOnboardCount(selectedStaff.User_ID).then(res => {
        if (res.success) {
          this.totalEnrollments = res.data.Total_Enrollments.length;
          this.recentEnrollments = res.data.Recent_Enrollments.length;

          if (this.totalEnrollments < 5) {
            this.progress = this.totalEnrollments;
            this.showProgress = true;
          }

          if (this.levels.includes(this.totalEnrollments)) {

            this.showEnrollmentNumbers = false;

            switch (this.totalEnrollments) {
              case 5:
                this.enrollments = 5;
                this.promotedEnrollerStatus = "Certified";
                this.enrollmentsRequired = 15;
                this.nextPromotedEnrollerStatus = "Wiz";
                break;
              case 20:
                this.enrollments = 20;
                this.promotedEnrollerStatus = "Wiz";
                this.enrollmentsRequired = 35;
                this.nextPromotedEnrollerStatus = "All Star";
                break;
              case 55:
                this.enrollments = 55;
                this.promotedEnrollerStatus = "All Star";
                this.enrollmentsRequired = 45;
                this.nextPromotedEnrollerStatus = "Champion";
                break;
              default:
                if (this.totalEnrollments >= 100) {
                  this.enrollments = 100;
                  this.promotedEnrollerStatus = "Champion";
                }
                break;
            }
          } else {
            this.showEnrollmentNumbers = true;
            if(this.totalEnrollments == 0) {
              this.currentStatus = "Untrained";
            } else if (this.totalEnrollments > 0 && this.totalEnrollments < 5) {
              this.currentStatus = "Trained";
            } else if (this.totalEnrollments > 5 && this.totalEnrollments < 20) {
              this.enrollmentsRequired = 20 - this.totalEnrollments;
              this.promotedEnrollerStatus = "Wiz";
              this.currentStatus = "Certified";
            } else if (this.totalEnrollments > 20 && this.totalEnrollments < 55) {
              this.enrollmentsRequired = 55 - this.totalEnrollments;
              this.promotedEnrollerStatus = "All Star";
              this.currentStatus = "Wiz";
            } else if (this.totalEnrollments > 55 && this.totalEnrollments < 100) {
              this.enrollmentsRequired = 100 - this.totalEnrollments;
              this.promotedEnrollerStatus = "Champion";
              this.currentStatus = "All Star";
            }
          }
        }
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content {
  text-align: center;
  overflow: auto;
  max-height: 99vh;
}

button {
  height: 40px;
  font-size: 14px;
  color: #fff;
  border: none;
  padding: 6px 12px;
  border-radius: 40px;
  background: #750097;
}

.compbutton {
  background: #2c6759;
}

button.send {
  border-radius: 4px;
}

.light-blue {
  color: #750097;
}

.green{
  color:#2c6759;
}

.dark-blue {
  color: #005AC0;
}

.long-text {
  word-wrap: break-word;
  overflow-wrap: break-word;
  max-width: 100%;
}

.enrollment-container {
  display: inline-block;
  border: 2px solid #ccc;
  border-radius: 10px;
  padding: 10px 20px 0px 20px;
}

.enrollment-text {
  color: #5D5D5D;
}

.enrollment-column {
  display: flex;
  justify-content: space-around;
}

.enrollment-text-number {
  font-size: 40px;
}

.column {
  text-align: center;
  margin: 10px;
}

.progress {
  display: inline-flex;
  justify-content: space-between;
  width: 300px;
}

.circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.completed {
  background-color: #20D8A1;
}

.no-check-mark {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid #AEB3BE;
  color: white;
}

.check-mark {
  width: 40px;
  height: 40px;
}

hr {
  border: 1px solid #9D9D9D;
  margin: 10px 40px;
}
</style>

<!-- Not "scoped" to style modal -->
<style>
.vm--container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.vm--overlay {
  background: rgba(8, 17, 53, 0.38) !important;
}

.vm--modal {
  text-align: center;
  border-radius: 4px !important;
  background: #ffffff;
  padding: 20px;
  height: auto !important;
  width: auto !important;
  max-width: 600px;
  top: auto !important;
  left: auto !important;
}
</style>